// Fills the product page delivery card with dates counted from today. The day offsets come from the product section settings.
if (!customElements.get('voltara-delivery')) {
  customElements.define('voltara-delivery', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-abroad')) return;
      const offset = name => Number(this.dataset[name]);
      const day = days => { const date = new Date(); date.setDate(date.getDate() + days); return date; };
      const locale = this.dataset.locale || 'en';
      const short = date => date.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
      const long = date => date.toLocaleDateString(locale, { weekday: 'short', month: 'short', day: 'numeric' });
      const fill = (key, text) => { const target = this.querySelector(`[data-delivery="${key}"]`); if (target) target.textContent = text; };
      const first = day(offset('arriveMin'));
      const last = day(offset('arriveMax'));
      fill('ordered', short(day(0)));
      fill('shipped', `${short(day(offset('shipMin')))} – ${short(day(offset('shipMax')))}`);
      fill('delivered', `${short(first)} – ${short(last)}`);
      fill('from', long(first));
      fill('to', long(last));
      this.querySelector('[data-delivery-static]').hidden = true;
      this.querySelector('[data-delivery-dynamic]').hidden = false;
      // The Halloween line only shows in the run-up, and only while the latest estimate still lands before October 31.
      const halloween = new Date(last.getFullYear(), 9, 31);
      this.querySelector('[data-delivery-halloween]').hidden = !(new Date().getMonth() >= 8 && last < halloween);
    }
  });
}
